export function Footer() {
  return (
    <footer className="mt-auto border-t border-border bg-primary-dark text-white">
      <div className="mx-auto max-w-6xl px-6 py-8 text-sm">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
          <div className="flex items-center gap-3">
            <img
              src="/logo-horizontal.webp"
              alt="Red de creadores de contenido Educrea"
              className="h-10 w-auto"
            />
            <div>
              <div className="text-base font-bold">Red de creadores de contenido Educrea</div>
              <div className="text-white/70">Panel de gestión de creadores</div>
            </div>
          </div>
          <div className="text-white/60">
            © {new Date().getFullYear()} Educrea · Carlos Montt 5611, Ñuñoa, Santiago
          </div>
        </div>
      </div>
    </footer>
  );
}
